// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  /*here we made css button */
  .update {
    position: absolute;
    right: 30px;
    top: 50px
  }

  .deletestore {
    height: calc(1.5em + 1.18rem + 2px);
    width: 80px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    background-color: #f96e6c;
    font-weight: 400;
    color: #ffff;
    line-height: 1.5;
    padding: 0.59rem 1rem;
  }

  .modal .popup {
    border-radius: 30px;
  }

  .separate_store input {
    height: 14px !important;
}

  .popup {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 50%;
    pointer-events: auto;
    background-color: #ffffff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    outline: 0;
    margin: auto;
  }

  select option {
    width: 200px;
    border-radius: 10px;
  }

  .fourButton {
    position: absolute;
    top: 80px;
    right: 60px;
  }

  .shopeName {
    position: absolute;
    top: 80px;
    margin-bottom: 10px;
    color: #56606e;
    font-size: 20px;
    font-weight: 500;
  }

  .successMessage {
    position: absolute;
    top: 110px;
    right: 500px;

  }

  .showMessage {
    display: block !important;
  }

  .hideMessage {
    display: none !important;
  }

  .updatedMessage {
    padding: 25px;
  }

  .cancelIcon {
    margin-top: -20px;
    margin-left: 9px;
    margin-right: -9px
  }

  .favi_icon {
    font-size: 12px;
  }

  .store_logo {
    /* position: absolute; */
    /* top: 3px; */
  }`, "",{"version":3,"sources":["webpack://./src/Components/Store/StoreEdit/StoreEditFormById.css"],"names":[],"mappings":"EAAE,2BAA2B;EAC3B;IACE,kBAAkB;IAClB,WAAW;IACX;EACF;;EAEA;IACE,mCAAmC;IACnC,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;AAC3B;;EAEE;IACE,kBAAkB;IAGlB,aAAa;IAIb,sBAAsB;IACtB,UAAU;IACV,oBAAoB;IACpB,yBAAyB;IACzB,4BAA4B;IAC5B,oCAAoC;IACpC,qBAAqB;IACrB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;;EAEd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,cAAc;EAChB","sourcesContent":["  /*here we made css button */\n  .update {\n    position: absolute;\n    right: 30px;\n    top: 50px\n  }\n\n  .deletestore {\n    height: calc(1.5em + 1.18rem + 2px);\n    width: 80px;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    background-color: #f96e6c;\n    font-weight: 400;\n    color: #ffff;\n    line-height: 1.5;\n    padding: 0.59rem 1rem;\n  }\n\n  .modal .popup {\n    border-radius: 30px;\n  }\n\n  .separate_store input {\n    height: 14px !important;\n}\n\n  .popup {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    width: 50%;\n    pointer-events: auto;\n    background-color: #ffffff;\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-radius: 0.3rem;\n    outline: 0;\n    margin: auto;\n  }\n\n  select option {\n    width: 200px;\n    border-radius: 10px;\n  }\n\n  .fourButton {\n    position: absolute;\n    top: 80px;\n    right: 60px;\n  }\n\n  .shopeName {\n    position: absolute;\n    top: 80px;\n    margin-bottom: 10px;\n    color: #56606e;\n    font-size: 20px;\n    font-weight: 500;\n  }\n\n  .successMessage {\n    position: absolute;\n    top: 110px;\n    right: 500px;\n\n  }\n\n  .showMessage {\n    display: block !important;\n  }\n\n  .hideMessage {\n    display: none !important;\n  }\n\n  .updatedMessage {\n    padding: 25px;\n  }\n\n  .cancelIcon {\n    margin-top: -20px;\n    margin-left: 9px;\n    margin-right: -9px\n  }\n\n  .favi_icon {\n    font-size: 12px;\n  }\n\n  .store_logo {\n    /* position: absolute; */\n    /* top: 3px; */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
